module.exports = __webpack_public_path__ + "img/DownArrow2.7b9bd588.svg";